import { useTranslations } from '@/hooks/useTranslations'
import { useCallback, useMemo, useState } from 'react'

import Fa6SolidMoneyBillTransfer from '~icons/fa6-solid/money-bill-transfer';

import { ModalLayout } from './_Modal'

type ConfirmSaveModalProps = {
  open: boolean
  setIsOpen: (open: boolean) => void
  onConfirm: () => void
  title?: string
  description?: string
  showIcon?: boolean
}

const ConfirmSave = ({ open, setIsOpen, onConfirm, title, description, showIcon = false }: ConfirmSaveModalProps) => {
  const t = useTranslations()

  return (
    <ModalLayout
      hero={showIcon ? <Fa6SolidMoneyBillTransfer className="size-48" /> : undefined}
      open={open}
      setIsOpen={setIsOpen}
      title={title ?? t('modals.confirm.title')}
      description={description ?? t('modals.confirm.description')}
      cancel={{
        label: t('buttons.not_now'),
      }}
      action={{
        label: t('buttons.confirm'),
        action: () => onConfirm(),
      }}
    />
  )
}

export const useConfirmSaveModal = () => {
  const [openConfirmSaveModal, setIsOpenConfirmSaveModal] = useState(false)

  const ConfirmSaveModal = useCallback(
    ({ onConfirm, title, description }: { onConfirm: () => void, title?: string, description?: string }) => {
      return (
        <ConfirmSave
          open={openConfirmSaveModal}
          setIsOpen={setIsOpenConfirmSaveModal}
          onConfirm={onConfirm}
          title={title}
          description={description}
        />
      )
    },
    [openConfirmSaveModal, setIsOpenConfirmSaveModal],
  )

  const showConfirmSaveModal = useCallback(() => {
    setIsOpenConfirmSaveModal(true)
  }, [setIsOpenConfirmSaveModal])

  return useMemo(
    () => ({
      showConfirmSaveModal,
      ConfirmSaveModal,
    }),
    [showConfirmSaveModal, ConfirmSaveModal],
  )
}
